import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertCircle, Check, Package, CalendarDays, FileText, BarChart3 } from 'lucide-react';

const TrialExpired = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const features = [
    { icon: Package, text: t('subscription.unlimitedPackages') },
    { icon: CalendarDays, text: t('subscription.unlimitedBookings') },
    { icon: FileText, text: t('subscription.documentStorage') },
    { icon: BarChart3, text: t('subscription.realTimeAnalytics') }
  ];

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
            <AlertCircle className="w-8 h-8 text-amber-600" />
          </div>
          <CardTitle className="text-2xl">{t('trialExpired.title')}</CardTitle>
          <CardDescription className="text-base">
            {t('trialExpired.trialEnded')}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-muted/50 p-4 rounded-lg">
            <p className="text-sm text-muted-foreground mb-4">
              {t('trialExpired.dataPreserved')}
            </p>
            <p className="text-sm font-medium text-foreground mb-3">{t('trialExpired.whatsIncluded')}</p>
            <ul className="space-y-2">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <li key={index} className="flex items-center gap-2 text-sm text-foreground">
                    <div className="w-5 h-5 rounded-full bg-primary/20 flex items-center justify-center">
                      <Check className="w-3 h-3 text-primary" />
                    </div>
                    {feature.text}
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="space-y-3">
            <Button 
              className="w-full" 
              size="lg"
              onClick={() => navigate('/subscription')}
            >
              {t('trialExpired.chooseAPlan')}
            </Button>
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => window.location.href = 'mailto:sales@2ds.fi'}
            >
              {t('trialExpired.contactSales')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TrialExpired;
